module.exports = __webpack_public_path__ + "assets/icon_main.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/icon_main.png
 ** module id = 115
 ** module chunks = 1
 **/